<script setup lang="ts">
import { computed } from "vue";
import { useDtfStore } from "../../store";

defineProps<{
  disabled: boolean;
}>();

const store = useDtfStore();
const isRedrawDelayTextVisible = computed(() => store.isRedrawDelayTextVisible);
const emit = defineEmits(["input"]);
const model = defineModel<string>({ default: "" });
</script>

<template>
  <div class="custom-notes">
    <label class="custom-notes__label">
      <span class="custom-notes__label-text">
        <span class="custom-notes__label-required">*</span>
        Instructions for our designers
      </span>
      <span v-if="isRedrawDelayTextVisible" class="custom-notes__note">
        Due to higher than normal volume, requesting design edits may delay your delivery date by 1
        day.
      </span>
      <textarea
        v-model="model"
        :disabled="disabled"
        class="custom-notes__textarea"
        maxlength="500"
        placeholder='Example: "Change the color of the font to black. Remove the background from the top half of the image."'
        @input="emit('input', $event)"
      ></textarea>
    </label>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.custom-notes {
  &__label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: $mirage;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
  }

  &__label-text {
    padding-right: 90px;
  }

  &__note {
    font-size: 11px;
    font-weight: normal;
  }

  &__label-required {
    color: $red-pure;
  }

  &__textarea {
    border-radius: 4px;
    padding: 8px;
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    resize: none;
    border: 1px solid $crafterpay-gray-modern-400;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
